import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const Aeroplane = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m14.134 6.992 3.396-3.397a2.033 2.033 0 0 1 2.875 2.875l-3.397 3.396 1.838 9.145c.235 1.17-2.034 2.8-2.638 1.25l-2.69-6.904-3.493 3.493c.17 2.041.475 3.15-1.224 4.15l-2.175-3.626L3 15.199c1-1.699 2.109-1.395 4.15-1.224l3.493-3.492-6.904-2.691c-1.55-.604.08-2.874 1.25-2.638z"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const ForwardRef = forwardRef(Aeroplane) as SvgIcon;
export { ForwardRef as ReactComponent };
